module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"numbers":"Numbers","display name":"Display name","number":"Number","is main":"Is main","premium number":"Premium number","start date":"Start date","end date":"End date"},"de":{"numbers":"Rufnummern","display name":"Anzeigename","number":"Rufnummer","is main":"Ist Hauptnummer","premium number":"Premium Nummer","start date":"Startdatum","end date":"Enddatum"}}')
  delete Component.options._Ctor
}
